module.exports = __webpack_public_path__ + "static/media/image-card-9.d1e7bcd5.png";